import { TableCustomerOrders} from "../TableCustomerOrders";
import { DataSource, Label, Layout} from "@mcleod/components";

export abstract class AutogenLayoutPopupTableCustomerOrders extends Layout {
	labelDetailForOrder: Label;
	layoutTableCustomerOrder: TableCustomerOrders;
	sourceOrders: DataSource;
}
